const productMixins = {
  props: {},
  data() {
    return {
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      proCatalogEnum: []
    }
  },
  mounted() {
    this.getProCatalogEnum()
  },
  methods: {
    getProCatalogEnum() {
      this.getHttpServices()
        .getUserService()
        .post('invoice/v2/getProCatalogEnum')
        .then(res => {
          this.proCatalogEnum = res
        })
        .catch(err => {
          console.error('======getProCatalogEnum=======', err)
        })
    },
    getModularProductPromise(params) {
      return this.getHttpServices().getUserService().post('homepage/recommend/get/modularProduct', params)
    },
    //选择产品弹窗header
    getGoodsColumns(exclusionOperation = false) {
      const list = [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '300px'
        },
        {
          title: '商品分类',
          dataIndex: 'proCatalog',
          width: '160px',
          scopedSlots: { customRender: 'proCatalog' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
      return exclusionOperation ? list.filter(item => item.dataIndex !== 'action') : list
    },
    getGroupRequest(params) {
      return this.getHttpServices().getProService().post('proGroup/findProGroupList', params)
    },
    getGroupColumns() {
      return [
        {
          title: 'id',
          dataIndex: 'groupId',
          width: '60px'
        },
        {
          title: '分组名称',
          dataIndex: 'groupName'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getProCatalogName(proCatalog, list) {
      if (proCatalog && list && list.length > 0) {
        const findItem = list.find(item => String(item.value) === String(proCatalog))
        return findItem && findItem.key ? findItem.key : ''
      }
      return ''
    }
  }
}
export default productMixins